<ng-container *transloco="let t; prefix: 'tasks.taskDetail.approvalFlow'">
  <div mat-dialog-title class="dialog-header">
    <span class="dialog-title headline-small">
      {{ t(data.isApproved ? 'approveTitle' : 'rejectTitle') }}
    </span>
  </div>

  <mat-dialog-content class="dialog-content">
    <span class="body-medium">
      {{ t('proposal', { number: data.proposalNumber }) }}
    </span>
    <span class="body-medium">{{ data.comment }}</span>
  </mat-dialog-content>

  <mat-dialog-actions class="dialog-actions">
    <button matButton type="button" [mat-dialog-close]="false">
      {{ t('cancel') }}
    </button>
    <button
      matButton="filled"
      type="button"
      [class.reject-confirm-button]="!data.isApproved"
      [mat-dialog-close]="true">
      {{ t(data.isApproved ? 'confirm' : 'rejectConfirm') }}
    </button>
  </mat-dialog-actions>
</ng-container>
